import axios from 'axios'
import Vue from 'vue';
import { Toast } from 'vant';
import { getToken_API } from '../apis/api'
Vue.use(Toast);
// 获取url上的userid
// let urlUserid = new URL(location.href).searchParams.get('userid');
// axios
const VueAxios = {
    vm: {},
    // eslint-disable-next-line no-unused-vars
    install(Vue, router = {}, instance) {
        if (this.installed) {
            return;
        }
        this.installed = true;
        if (!instance) {
            // eslint-disable-next-line no-console
            console.error('You have to install axios');
            return;
        }
        Vue.axios = instance;
        Object.defineProperties(Vue.prototype, {
            axios: {
                get: function get() {
                    return instance;
                }
            },
            $http: {
                get: function get() {
                    return instance;
                }
            }
        });
    }
};

let apiBaseUrl = window._CONFIG['domianURL'] || "/jeecg-boot";
// 创建 axios 实例
const service = axios.create({
    baseURL: apiBaseUrl, // api base_url
    timeout: 9000 // 请求超时时间
})

//const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3ODcyNzU5MTYsInVzZXJuYW1lIjoiMjAzOTc4ODUifQ.gJjAS_AEF5jAx4SeRxt9B-TiwviV2fDgMpr7qCKhSYk'
//localStorage.setItem('X-Access-Token',token)
// request interceptor
service.interceptors.request.use(config => {
    const token = localStorage.getItem("X-Access-Token")
    if(config.url == config.baseURL + '/sys/common/upload') {
        config.headers[ 'Content-Type' ] = 'multipart/form-data'
    }
    if (token) {
        config.headers[ 'X-Access-Token' ] = encodeURIComponent(token) // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config
},(error) => {
    return Promise.reject(error)
})

// 防抖：避免多个请求同时触发重复跳转
let isTokenExpiredRedirecting = false;
function handleTokenExpired(message) {
    if (isTokenExpiredRedirecting) return;
    isTokenExpiredRedirecting = true;
    localStorage.removeItem('X-Access-Token');
    Toast.fail(message);
    setTimeout(() => {
        isTokenExpiredRedirecting = false;
        window.location.href = '/login';
    }, 1500);
}

// response interceptor
service.interceptors.response.use((response) => {
    return response.data
}, (error) => {
    if (error.response) {
        let data = error.response.data
        // console.log("------异常响应------",error.response.status)
        switch (error.response.status) {
            case 403:
                Toast.fail("拒绝访问")
                break
            case 500:
                handleTokenExpired("Token失效, 请重新登录!")
                break
            case 404:
                Toast.fail("很抱歉，资源未找到!")
                break
            case 504:
                Toast.fail("网络超时")
                break
            case 401:
                handleTokenExpired("未授权，请重新登录")
                break
            default:
                Toast.fail(data.message)
                break
        }
    } else {
        if(error) {
            Toast.fail("请求超时" || error.data.message)
        } else {
            Toast("Failed to load response data")
        }
    }
    return Promise.reject(error)
})

const installer = {
    vm: {},
    install (Vue, router = {}) {
        Vue.use(VueAxios, router, service)
    }
}

export {
    installer as VueAxios,
    service as axios
}